import { render } from "./perfectQuotes.vue?vue&type=template&id=360a7bfe&scoped=true"
import script from "./perfectQuotes.vue?vue&type=script&lang=js"
export * from "./perfectQuotes.vue?vue&type=script&lang=js"

import "./perfectQuotes.vue?vue&type=style&index=0&id=360a7bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360a7bfe"]])

export default __exports__